import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { DocumentLibraryStore } from './../stores/documentLibraryStore';

export const useDocumentLibraryStore = () => useContext<{
  documentLibraryStore: DocumentLibraryStore
}>(StoreContext);
